import merge from 'lodash/merge';

import {
    MANAGE_ORDER_LOCK,
    TOGGLE_SERVICE_TIMEOUT,
    RECEIVE_UTILITY,
    RECEIVE_USER_IDLE,
    NULL_UTIL_STATE
} from './utility-actions';



const UtilityReducer = (state = NULL_UTIL_STATE, action) => {
    Object.freeze(state);
    const newState = merge({}, state);
    switch (action.type) {
        case RECEIVE_UTILITY:
            newState.profileData = action.utilityInfo.profileData;
            if(action.updatedFromService === true){
                newState.updatedFromService = true
            }
            return newState;
        case MANAGE_ORDER_LOCK:
            newState.callCenter.orderLock = action.orderLock;
            return newState;
        case TOGGLE_SERVICE_TIMEOUT:
            newState.serviceTimeout = action.toggle;
            return newState;
        case RECEIVE_USER_IDLE:
            newState.userIdle = action.userIdle;
            return newState;
        default:
            return state;
    }
};

export default UtilityReducer;
